<template>
  <div ref="recipients" class="recipients-graph-section">
    <h5 class="data-title text-center">recipients vs non recipients</h5>

    <select-by-type @setDataType="setReportDataType"></select-by-type>

    <div v-if="errorMessage"
         class="error-label text-center">
      {{errorMessage}}
    </div>

    <div v-if="graphData && graphData.length && !error"
         class="report-legend recipients">
      <span class="recipients-legend">recipients</span>
      <span class="non-recipients-legend">non-recipients</span>
    </div>

    <bar-graph
        v-if="graphData && wrapperWidth"
        :barSelectorData="['recipient', 'nonrecipient']"
        :graphData="graphData"
        :toolTipContent="toolTipContent"
        :useCurrency="useCurrency"
        :wrapperWidth="wrapperWidth"
        xSelector="date_time"
        :yTickFormat="yTickFormat"
        :margin="$refs.recipients.clientWidth > 500 ? 20 : 14"
        @setToolTipContent="setToolTipContent">
    </bar-graph>
  </div>
</template>

<script>
  import BarGraph from '../Graphs/BarGraph'
  import ReportsMixin from '../../mixins/ReportsMixin'
  import SelectByType from './SelectByType'
  import ToolTipContentMixin from '../../mixins/ToolTipContentMixin'

  export default {
    props: {
      error: String,
      graphData: Array,
      isTracked: Boolean,
      wrapperWidth: [Number, String],
    },

    name: 'RecipientsReport',

    components: {
      BarGraph,
      SelectByType,
    },

    mixins: [ReportsMixin, ToolTipContentMixin],

    data() {
      return {
        errorMessage: null,
        returnMetricParams: true,
        showDataTypeList: false,
        toolTipContent: null,
      }
    },

    methods: {
      setReportDataType(dataType) {
        if (dataType && this.reportDataType !== dataType) {
          this.reportDataType = dataType
          this.$emit('loadGraphData', 'conversion_rate', 'recipients', this.metric)
        }
      },

      setToolTipContent(item) {
        this.toolTipContent = this.getToolTipContent(item, 'recipients')
      },
    },

    created() {
      this.$emit('loadGraphData', 'conversion_rate', 'recipients', this.metric)
    },
  }
</script>
